export enum RESPONSE_TYPES {
  JSON = 'json',
  BLOB = 'blob',
  ARRAY_BUFFER = 'arrayBuffer',
  FORM_DATA = 'formData',
  TEXT = 'text',
}
